import { motion } from "framer-motion";
import { Brain, Crosshair, Radar, Network, ShieldCheck, Swords } from "lucide-react";
import { Overline } from "../Reveal";

const services = [
  {
    icon: Crosshair,
    title: "Pentesting Ofensivo",
    desc: "Explotación controlada de tu infraestructura, apps y APIs. Encontramos el fallo antes que el atacante.",
    span: "lg:col-span-4",
    img: "https://images.pexels.com/photos/5380664/pexels-photo-5380664.jpeg?auto=compress&cs=tinysrgb&w=1200",
    tag: "RED TEAM",
  },
  {
    icon: Brain,
    title: "IA & OSINT",
    desc: "Inteligencia de fuentes abiertas potenciada por IA para mapear tu exposición real.",
    span: "lg:col-span-2",
    tag: "INTELLIGENCE",
  },
  {
    icon: Radar,
    title: "SOC 24/7",
    desc: "Monitorización y respuesta continua. Detección de amenazas en tiempo real, todos los días.",
    span: "lg:col-span-2",
    tag: "DEFENSE",
  },
  {
    icon: Network,
    title: "Ciberinteligencia",
    desc: "Análisis de actores de amenaza, dark web y campañas dirigidas contra tu sector.",
    span: "lg:col-span-2",
    tag: "INTEL",
  },
  {
    icon: ShieldCheck,
    title: "Defensa Digital",
    desc: "Arquitecturas zero-trust, hardening y planes de respuesta ante incidentes que resisten el mañana.",
    span: "lg:col-span-2",
    tag: "GUARDIAN",
    accent: true,
  },
];

const Card = ({ s, i }) => {
  const Icon = s.icon;
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ y: -6 }}
      data-testid={`service-card-${i}`}
      className={`group relative flex min-h-[16rem] flex-col justify-between overflow-hidden rounded-2xl border border-white/10 p-8 transition-colors duration-500 hover:border-cyber-cyan/50 ${s.span} ${
        s.accent ? "bg-cyber-cyan/[0.06]" : "bg-white/[0.03]"
      }`}
    >
      {s.img && (
        <>
          <img src={s.img} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20 transition-opacity duration-500 group-hover:opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#070a14] via-[#070a14]/70 to-transparent" />
        </>
      )}
      <div className="relative z-10 flex items-center justify-between">
        <Icon className="h-8 w-8 text-cyber-cyan" strokeWidth={1.5} />
        <span className="font-mono-tech text-[10px] uppercase tracking-[0.2em] text-white/40">
          {s.tag}
        </span>
      </div>
      <div className="relative z-10">
        <h3 className="font-head text-xl font-semibold text-white md:text-2xl">
          {s.title}
        </h3>
        <p className="mt-3 max-w-sm font-sans text-sm leading-relaxed text-white/60">
          {s.desc}
        </p>
      </div>
    </motion.div>
  );
};

export const Services = () => (
  <section
    id="servicios"
    className="relative mx-auto max-w-7xl px-5 py-28 md:px-10 md:py-40"
    data-testid="services"
  >
    <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
      <div>
        <Overline>Capacidades</Overline>
        <h2 className="mt-6 max-w-2xl font-head text-4xl font-bold tracking-tight text-white md:text-5xl">
          Un arsenal completo de defensa ofensiva
        </h2>
      </div>
      <p className="max-w-xs font-sans text-sm text-white/50">
        Desde el reconocimiento hasta la vigilancia continua — cubro todo el ciclo de vida de la ciberseguridad.
      </p>
    </div>

    <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-6">
      {services.map((s, i) => (
        <Card key={s.title} s={s} i={i} />
      ))}
    </div>
  </section>
);
